import { S as Swiper } from './swiper-core-Bbvcim4W.js';
import { P as Pagination } from './pagination-B1NmdghC.js';
import { A as A11y } from './a11y-SU9kYSAf.js';

class PageBlocksSlider extends HTMLElement {
  connectedCallback() {
    this.swiperElement = this.querySelector('[data-swiper]');

    new Swiper(this.swiperElement, {
      modules: [A11y, Pagination],
      slidesPerView: 1,
      threshold: 10,
      preventClicks: true,
      preventClicksPropagation: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}

customElements.define('page-blocks-slider', PageBlocksSlider);
